import { Injectable } from "@angular/core";
import {
  PRIMITIVE,
  ClientMessageBrokerFactory,
  ClientMessageBroker,
  FnArg,
  UiArguments,
} from "shared/provider-webworker";

import { ReplicaLookupService } from "../../impl/ReplicaLookupService";
import { ICcyPromiseLookupService } from "../ICcyPromiseLookupService";
import { BaseLookupService } from "../../impl/BaseLookupService";
import { PromiseLookupService } from "../../impl/PromiseLookupService";
import { CcyLookupService } from "./CcyLookupService";

import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class CcyReplicaLookupService
  extends ReplicaLookupService<string, CubiqTS.CurrencyImpl>
  implements ICcyPromiseLookupService
{
  constructor(protected factory: ClientMessageBrokerFactory) {
    super(
      factory,
      CubiqTS.CurrencyImpl,
      "CurrencyImpl",
      CubiqTS.ModelUpdateImpl,
      true,
      new CcyLookupService(),
    );
  }

  getCcy(code: string): Promise<CubiqTS.CurrencyImpl> {
    let request = new UiArguments("getCcy");
    let arg1 = new FnArg(code, PRIMITIVE);
    request.args = [arg1];
    return this.broker.runOnService(request, this.VALUE);
  }
}
